<div class="cv-photo-sub-interior" *ngIf="info; else emptySelection">
	<cv-tab-group class="cv-photo-sub-exterior__paging">
		<cv-tab
			*ngFor="let def of info; let i = index"
			[active]="i === 0"
			[title]="info.length > 1 ? (i + 1).toString(0) : ''"
		>
			<div class="cv-photo-sub-interior__tab-content">
				<div class="gallery-photo" *ngIf="def.cv_photos">
					<!--<ngx-gallery [options]="galleryOptions" [images]="def.cv_photos[0].path"></ngx-gallery>-->
					<cv-gallery [album]="def.cv_photos[0].path" [options]="options"></cv-gallery>
				</div>
				<div class="gallery-photo" *ngIf="!def.cv_photos">
					<label>No photo available</label>
				</div>
				<div class="filled-columm columm-field">
					<label>Deficiency name</label>
					<label class="columm-value">{{ def.deficiencyName || noInfo }}</label>
				</div>
				<div class="columm-field">
					<label>Deficiency type</label>
					<label class="columm-value">{{ def.deficiencyType || noInfo }}</label>
				</div>
				<div class="filled-columm columm-field">
					<label>Deficiency severity</label>
					<label class="columm-value">{{ def.interiorDeficiencySeverity || noInfo }}</label>
				</div>
				<div class="columm-field">
					<label> Deficiency description</label>
					<label class="columm-value">{{ def.descriptionInteriorDeficiency || noInfo }}</label>
				</div>
			</div>
		</cv-tab>
	</cv-tab-group>
</div>
<ng-template #emptySelection>
	<div class="cv-photo-sub-interior-noSelection">
		<label><i class="far fa-images"></i> Select a Photo to review</label>
	</div>
</ng-template>
